import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import {
  Button,
  DatePicker,
  Flex,
  Image,
  Input,
  notification,
  PaginationProps,
  Table,
  TableColumnsType,
} from "antd";
import {
  Calendar2,
  Clock,
  DocumentDownload,
  Home2,
  SearchZoomIn1,
} from "iconsax-react";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LineOutlined,
} from "@ant-design/icons";
// import tableData from './cashout-table-data.json'
// import dayjs from 'dayjs';
import "./Cashout.scss";
import * as XLSX from "xlsx";
import { mixPostV1 } from "../../services/mixin";
import { IMAGE_URL } from "../../env";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const fallbackAvatar =
  "data:image/png;base64,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";

const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days before today and today
  return current && current > dayjs().endOf("day");
};

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

interface DataType {
  key: React.Key;
  date: string;
  staff: string;
  shift: number;
  customerName: string;
  appId: string;
  match: number;
  cashOut: number;
  imgProof: string;
  imgCreatedAt: string;
}

const StaffCashOut: React.FC = () => {
  const columns: TableColumnsType<DataType> = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Staff",
      dataIndex: "staff",
      key: "staff",
    },
    {
      title: "Shift",
      dataIndex: "shift",
      key: "shift",
    },
    {
      title: "Customer name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "App ID",
      dataIndex: "appId",
      key: "appId",
    },
    {
      title: "Machine",
      dataIndex: "machine_number",
      key: "machine_number",
    },
    {
      title: "Match",
      dataIndex: "match",
      key: "match",
    },
    {
      title: "Cash-out",
      dataIndex: "cashOut",
      key: "cashOut",
    },
    {
      title: "Img proof",
      dataIndex: "imgProof",
      key: "imgProof",
      render: (text, record) =>
        text ? (
          <Flex align="center" gap={12}>
            <Image
              height={40}
              width={40}
              src={`${text}`}
              alt={record.customerName}
              preview={{
                src: `${text}`,
              }}
              style={{ borderRadius: "50%", overflow: "hidden" }}
              fallback={fallbackAvatar}
            />
            <span>{record.imgCreatedAt}</span>
          </Flex>
        ) : (
          ""
        ),
    },
  ];

  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState({
    limit: 10,
    page_number: 1,
  } as any);

  let wait = false;
  const getItems = async () => {
    if (wait === true) {
      return;
    }
    wait = true;
    setTableLoading(true);
    const res = await mixPostV1(
      "/api/webAdmin/gListStaffCashoutByStore.php",
      params
    );
    wait = false;
    if (res.status === 1) {
      const result: any = [];
      res.data.map((item: any) =>
        result.push({
          ...item,
          key: item.id,
          staffId: item.id,
          staff: item.staff_name,
          // sex: item.gender_id,
          sex: item.gender_name,
          phoneNumber: item.phone_number,
          clockIn: item.clockin,
          dob: item.birthday,
          customerName: item.customer_name,
          appId: item.app_id,
          date: item.timecashout,
          imgProof: item.photo_url,
          cashOut: item.match_amount,
          match: item.match_customer_plans,
        })
      );
      setItems({
        ...items,
        list: result,
        total: res.total,
      });
      setTableLoading(false);
    }
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };

  const dayRangeChange = (data: any, str: any) => {
    setParams({
      ...params,
      page_number: 1,
      dateStart: str[0],
      dateEnd: str[1],
    });
  };

  let timeout = null as any;
  const searchKeyChange = (value: string) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setParams({ ...params, page_number: 1, searchStaffName: value });
    }, 200);
  };

  let timeout2 = null as any;
  const searchShiftChange = (value: string) => {
    clearTimeout(timeout2);
    timeout2 = setTimeout(() => {
      setParams({ ...params, page_number: 1, searchShift: value });
    }, 200);
  };

  // END GET LIST

  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gListStaffCashoutByStore.php",
        customParams
      );

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
        } else {
          openNotification("error", "There is no data to export!");
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        Date: item.timecashout,
        Staff: item.staff_name,
        Shift: item.shift,
        "Customer Name": item.customer_name,
        AppId: item.app_id,
        Match: item.match_customer_plans,
        "Cash Out": item.match_amount,
        "Img Proof": item.photo_url ? `${IMAGE_URL}${item.photo_url}` : "",
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"StaffCashoutByStore"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!"
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  return (
    <>
      {contextHolder}

      <Layout contentClassName="staff-cashout-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Staff" },
            { title: "Match/Cash-out" },
          ]}
          title="Match/Cash-out"
          description=""
        />

        <div className="table-filter-block">
          <Input
            allowClear
            placeholder="Search by staff name or customer"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            className="rs-input"
            onChange={(e) => searchKeyChange(e.target.value)}
          />

          <Input
            allowClear
            placeholder="Shift"
            prefix={<Clock size={20} variant="Bulk" />}
            className="rs-input"
            type="Number"
            onChange={(e) => searchShiftChange(e.target.value)}
          />

          {/* <Select
            defaultValue="-1"
            options={[
              { value: 'staff-working', label: 'Staff working today' },
              { value: 'staff-off', label: 'Staff off' },
            ]}
            placeholder="Select Staff"
            popupMatchSelectWidth={false}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            className="rs-select"
            labelRender={({ label }) => {
              return (
                <Flex align='center' gap={8}>
                  <UserSquare size={20} variant="Bulk"/><span>{ label ? label : 'Select Staff' }</span>
                </Flex>
              )
            }}
          /> */}

          <RangePicker
            className="rs-range-picker"
            popupClassName="rs-range-picker-dropdown"
            suffixIcon={<Calendar2 size={20} />}
            separator={<LineOutlined />}
            placeholder={["From date", "To date"]}
            disabledDate={disabledDate}
            onChange={(e, str) => dayRangeChange(e, str)}
          />

          {/* <Select
            defaultValue={'shift'}
            placeholder="Shift"
            options={[ { value: 'shift', label: 'Shift'} ]}
            popupMatchSelectWidth={false}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            className="rs-select"
            popupClassName='rs-select-dropdown'
            labelRender={({ label }) => {
              return (
                <Flex align='center' gap={8}>
                  <Clock size={20} variant="Bulk"/><span>{ label ? label : 'Shift' }</span>
                </Flex>
              )
            }}
          /> */}

          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button"
            onClick={getItemsByExcel}
          >
            Export
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={items.list}
          className="rs-table table-text-nowrap match-height"
          loading={tableLoading}
          scroll={{
            x: true,
          }}
          pagination={{
            current: params.page_number,
            pageSize: params.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            total: items.total,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange(e),
          }}
          onChange={onTableChange}
        />
      </Layout>
    </>
  );
};

export default StaffCashOut;
